module.exports = __webpack_public_path__ + "img/hood-cloak.d831e8dc.svg";